import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { StoreEmployeeAvailability } from '../../../models/employee/StoreEmployeeAvailability';
import { Availability } from '../../../models/employee/Availability';
import {
  EmployeeAvailabilityResponse,
  StoreEmployeeAvailabilityResponse
} from '../../../../interfaces/response/EmployeeResponse';
import { DayOfWeek } from '../../../enums/DayOfWeek';
import { EmployeePositionId } from '../../../models/employee/Employee';

/**
 * An adapter converts employee's availabilities HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreEmployeeAvailabilityAdapter implements Adapter<StoreEmployeeAvailability> {

  /**
   * Converts employee's availabilities HTTP response to {@link StoreEmployeeAvailability}.
   * @param item employee's availabilities HTTP response.
   */
  adapt(item: StoreEmployeeAvailabilityResponse): StoreEmployeeAvailability {
    if (!item) {
      return null;
    }

    const availabilities = new Map<string, Availability[]>();
    item.availabilities.forEach($item => {
      const weeklyAvailabilities: Availability[] = [];
      weeklyAvailabilities.push(this.asAvailability($item.date, DayOfWeek.MONDAY, $item.monday));
      weeklyAvailabilities.push(this.asAvailability($item.date, DayOfWeek.TUESDAY, $item.tuesday));
      weeklyAvailabilities.push(this.asAvailability($item.date, DayOfWeek.WEDNESDAY, $item.wednesday));
      weeklyAvailabilities.push(this.asAvailability($item.date, DayOfWeek.THURSDAY, $item.thursday));
      weeklyAvailabilities.push(this.asAvailability($item.date, DayOfWeek.FRIDAY, $item.friday));
      weeklyAvailabilities.push(this.asAvailability($item.date, DayOfWeek.SATURDAY, $item.saturday));
      weeklyAvailabilities.push(this.asAvailability($item.date, DayOfWeek.SUNDAY, $item.sunday));
      availabilities.set($item.date, weeklyAvailabilities);
    });
    return new StoreEmployeeAvailability(
      new EmployeePositionId(item.employeeId, item.positionId),
      availabilities
    );
  }

  private asAvailability(
    date: string,
    dayOfWeek: DayOfWeek,
    availabilityResponse: EmployeeAvailabilityResponse
  ): Availability {
    const startTime = availabilityResponse ? availabilityResponse.startTime : null;
    const endTime = availabilityResponse ? availabilityResponse.endTime : null;
    return new Availability(dayOfWeek, startTime, endTime, date);
  }
}
